import Layout from 'components/Layout/Layout';
import { Outlet } from 'react-router';
import ThemeProvider from '@trackman/web-shared-components/styles/Theme';

export const App = () => {
  return (
    <ThemeProvider>
      <Layout>
        <Outlet />
      </Layout>
    </ThemeProvider>
  );
};

export default App;
